var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-hamburger slideout-menu-container" },
    [
      _c(
        "Slideout",
        {
          attrs: {
            easing: "cubic-bezier(.32,2,.55,.27)",
            menu: "#menu",
            panel: "#panel",
            toggleSelectors: [".hamburger"]
          }
        },
        [
          _c("main", { attrs: { id: "panel" } }, [
            _c("header", [
              _c(
                "div",
                {
                  staticClass: "hamburger-container",
                  attrs: {
                    tabindex: "0",
                    role: "button",
                    "aria-label": "user menu"
                  },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.toggleNav()
                    }
                  }
                },
                [
                  _c("BaseIcon", {
                    attrs: {
                      icon: "bars",
                      size: "2x",
                      classNames: [{ hamburger: true, "is-clickable": true }]
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("nav", { ref: "slideoutMenu", attrs: { id: "menu" } }, [
        _c("div", { staticClass: "nav-menu-items" }, [
          _c(
            "div",
            [
              _c("BaseIcon", {
                attrs: {
                  tabindex: "0",
                  role: "button",
                  "aria-label": "close settings",
                  icon: "times",
                  size: "2x",
                  classNames: [
                    {
                      "is-clickable": true,
                      "store-navigation-color": true,
                      "close-icon": true
                    }
                  ]
                },
                on: { click: _vm.closeSlideout }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "no-highlight", attrs: { id: "links" } },
            [
              _vm._l(_vm.links, function(link, index) {
                return [
                  !link.isModal
                    ? _c("NavigationItem", {
                        key: index,
                        attrs: { title: link.title, route: link.route },
                        on: { click: _vm.toggleNav }
                      })
                    : _c(
                        "a",
                        {
                          key: index,
                          staticClass: "is-size-5",
                          attrs: { href: "/?" + link.title },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return (function() {
                                _vm._triggerModal(link)
                                _vm.toggleNav()
                              })($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "slideout-navbar-item" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(link.title) +
                                "\n\t\t\t\t\t\t\t\t"
                            )
                          ])
                        ]
                      )
                ]
              })
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67ab9a7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67ab9a7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/SlideoutMenu.vue
// module id = null
// module chunks = 